import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  AppBar, Box, Divider, Toolbar, Typography
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import userService from 'src/services/userService';
import moment from 'moment';
import RepoList from './RepoList';
import Progress from './progress';
import Account from './Account';
import Role from './Role';

const useStyles = makeStyles(() => ({
  toolbar: {
    minHeight: 47,
  }
}));

function TopBar({ displayRepo }) {
  const classes = useStyles();
  const account = useSelector((state) => state.account);
  const selectedRepo = useSelector((state) => state.repository.selected);
  const [posts, setPosts] = useState([]);

  const ShowLastLogin = () => {
    useEffect(() => {
      async function fetchData() {
        try {
          const userOptions = await userService.getUserOptions(account.user?.id);
          const lastLoginForUser = userOptions.lastLogin;
          let d = moment(lastLoginForUser).format('MMMM Do YYYY, h:mm:ss a');
          d += ' ';
          d += userOptions.serverTimeZone;
          setPosts(d);
        } catch (err) {
          setPosts('');
        }
      }
      fetchData();
    }, [account.user]);
    return <div>{posts}</div>;
  };

  const getRole = () => {
    if (account.user?.isAdmin) {
      return 'Admin';
    }
    if (account.user?.isManager) {
      return 'Manager';
    }
    if (account.user?.isManagerOfUsers) {
      return 'Manager Of Users';
    }

    return 'User';
  };

  return (
    <AppBar
      position="relative"
      elevation={0}
      style={{ background: '#F4F6F8' }}
    >
      <Toolbar className={classes.toolbar}>
        {selectedRepo && displayRepo
          ? (
            <>
              <Divider orientation="vertical" flexItem />
              <Box>
                <RepoList />
              </Box>
              <Divider orientation="vertical" flexItem />
            </>

          ) : ''}

        <Box mx={2} flexGrow={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Progress />
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box mx={2} flexGrow={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography style={{ fontSize: 12, fontWeight: 500, marginRight: 4 }} color="#546E7A">
            Last login :
            {ShowLastLogin()}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box mx={2}>
          <Role role={getRole()} />
        </Box>

        <Divider orientation="vertical" flexItem />
        {
          !account.user?.isDisplayDocUser &&
          (
            <Box>
              <Account username={account.user && account.user.name} />
            </Box>
          )
        }
        <Divider orientation="vertical" flexItem />

      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  displayRepo: PropTypes.bool,
};

export default TopBar;
